import { Theme } from '@chakra-ui/react'

export interface NucbaFontSizesTheme extends Partial<Theme['fontSizes']> {}

export const fontSizes: NucbaFontSizesTheme = {
  '3xs': '0.5rem', // 8px
  '2xs': '0.625rem', // 10px
  xs: '0.75rem', // 12px
  sm: '0.9375rem', // 15px
  md: '1.0625rem', // 17px
  lg: '1.125rem', // 18px
  xl: '1.25rem', // 20px
  '2xl': '1.75rem', // 28px
  '7xl': '4.375rem', // 70px
}
